import { render, staticRenderFns } from "./SubItem.vue?vue&type=template&id=2a200f38&scoped=true"
import script from "./SubItem.vue?vue&type=script&lang=js"
export * from "./SubItem.vue?vue&type=script&lang=js"
import style0 from "./SubItem.vue?vue&type=style&index=0&id=2a200f38&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a200f38",
  null
  
)

export default component.exports